import React, { Component } from 'react';
import { Wrapper } from "components";
import styled from "react-emotion";
import Img from 'gatsby-image';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const EndorsementSlider = styled.div`
    background-color: ${props => props.theme.colors.greyLightBg};
`;

const EndorsementSlide = styled.div`
    text-align: center;
    margin-top: 3rem;
    margin-bottom: 3rem;
`;

const Endorsement = styled.h4`
    font-family: 'Rubik';
    padding-left: 3rem;
    padding-right: 3rem;
    font-style: italic;
    &:before {
        content: '"'
    }
    &:after {
        content: '"'
    }
`;

const Attribution = styled.p`
    font-size: 0.75rem;
    &:before {
        content: '- '
    }
`;

const ImageContainer = styled.div`
    margin-left: auto;
    margin-right: auto;
    width: 10%;
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        width: 25%;
    }
`;

class Endorsements extends Component {
    render() {
        const { endorsements } = this.props;

        const settings = {
            autoplay: true,
            autoplaySpeed: 4000,
            dots: false,
            arrows: false,
            infinite: true,
            speed: 750,
            slideToShow: 1,
            slidesToScroll: 1
        };
        return (
            <EndorsementSlider>
                <Slider {...settings}>
                    <EndorsementSlide>
                        <Wrapper>
                            <Endorsement>{endorsements.endorsement_1.text}</Endorsement>
                            <Attribution>{endorsements.attribution_1.text}</Attribution>
                            <ImageContainer><Img fluid={endorsements.image_1.localFile.childImageSharp.fluid} /></ImageContainer>
                        </Wrapper>
                    </EndorsementSlide>
                    {/* <EndorsementSlide>
                        <Wrapper>
                            <Endorsement>{endorsements.endorsement_2.text}</Endorsement>
                            <Attribution>{endorsements.attribution_2.text}</Attribution>
                            <ImageContainer><Img fluid={endorsements.image_2.localFile.childImageSharp.fluid} /></ImageContainer>
                        </Wrapper>
                    </EndorsementSlide>
                    <EndorsementSlide>
                        <Wrapper>
                            <Endorsement>{endorsements.endorsement_3.text}</Endorsement>
                            <Attribution>{endorsements.attribution_3.text}</Attribution>
                            <ImageContainer><Img fluid={endorsements.image_3.localFile.childImageSharp.fluid} /></ImageContainer>
                        </Wrapper>
                    </EndorsementSlide> */}
                </Slider>
            </EndorsementSlider>);
    }
}

export default Endorsements;